import { render, staticRenderFns } from "./SubHireDetailsPage.vue?vue&type=template&id=12486ba8"
import script from "./SubHireDetailsPage.vue?vue&type=script&lang=js"
export * from "./SubHireDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports